module.exports = __webpack_public_path__ + "img/unsure-choice.adb3c42.png";